import { FC, memo } from 'react';
import { ShipmentOrderLegRunForPlanEntity } from 'src/entities/ShipmentOrderLegRun.entity';

import OrderPolylinePresenter from './OrderPolylinePresenter';

type Props = {
  selectedIds: number[];
  shipmentOrderLegRunEntityMap: Map<number, ShipmentOrderLegRunForPlanEntity>;
}

const OrderPolylinesPresenter: FC<Props> = memo((
  {
    selectedIds,
    shipmentOrderLegRunEntityMap
  }
) => (
  <>
    {selectedIds.map((id) => (
      <OrderPolylinePresenter
        key={[
          'OrderPolylinesPresenter',
          'OrderPolylinePresenter',
          id
        ].join('-')}
        id={id}
        shipmentOrderLegRunEntityMap={shipmentOrderLegRunEntityMap}
      />
      ))}
  </>
));

export default OrderPolylinesPresenter;
